export default {
  '4xl': '2rem',
  '5xl': '3rem',
  '6xl': '4rem',
  half: '50%',
  avatarOutside: '20%',
  avatar: '19%',
  avatarInside: '17%',
};
